/**
 * Header banner for the standalone question layout.
 *
 * Full-width, full-bleed highlight background at the top of standalone pages.
 * Uses CSS subgrid to align with parent grid columns; actual header content
 * (title, meta row) is rendered by `QuestionHeaderContent` passed in as
 * children.
 */

import { useTheme } from '@repo/theme';
import React from 'react';

export type StandaloneQuestionHeaderProps = {
    fullWidth?: boolean;
    children: React.ReactNode;
    backgroundColor?: string;
};

// Full-bleed wrapper for standalone layout (question and composer). Responsive
// behavior is handled by QuestionHeaderContent.
export function StandaloneQuestionHeader({ children, fullWidth, backgroundColor }: StandaloneQuestionHeaderProps) {
    const { colors } = useTheme();
    return (
        <div
            style={{
                gridColumn: '1 / -1',
                display: 'grid',
                gridTemplateColumns: 'subgrid',
                backgroundColor: backgroundColor ?? colors.colorSurfaceHighlight,
            }}
        >
            <div
                style={{
                    gridColumn: fullWidth ? 'content-start / rail-end' : 'content-start / content-end',
                    alignContent: 'center',
                    justifyContent: 'space-between',
                }}
            >
                {children}
            </div>
        </div>
    );
}
